module.exports = __webpack_public_path__ + "img/thumb_11.e18c0fbf.jpg";